module.exports = __webpack_public_path__ + "img/twitterDark.49f4a47a.svg";